export default __webpack_public_path__ + "static/media/help3.93816f77.svg";